/* src/course_approvals/Scene.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import AddCourses from './cards/AddCourses';
import CourseApprovalCard from './cards/CourseApprovalCard';
import CourseApprovalListCard from './cards/CourseApprovalListCard';

const CourseApprovals = ({ classes }) => (
  <Grid container className={classes.root} spacing={16}>
    <Grid item xs={12} sm={6}>
      <CourseApprovalListCard />
    </Grid>
    <Grid item xs={12} sm={6}>
      <Grid container spacing={16}>
        <Grid item xs={12}>
          <CourseApprovalCard />
        </Grid>
        <Grid item xs={12}>
          <AddCourses />
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

const styles = () => ({
  root: {
    flexGrow: 1,
  },
});

CourseApprovals.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CourseApprovals);



// WEBPACK FOOTER //
// ./src/modules/course_approvals/Scene.js